import Vue from "vue";
import { errorServeiceHandler, makeQueryFormDataDyn } from "../../helper";

const actions = {
  // actPostRetrack: (context, payload) => {
  //   return new Promise((resolve, reject) => {
  //     if (!payload) {
  //       reject({ error: "payload not found" });
  //     }
  //     let data = makeQueryFormDataDyn(payload);
  //     fetch(context.getters.baseUrl + "/subscriber/v1/retrack", {
  //       method: "POST",
  //       body: data
  //     })
  //       .then(errorServeiceHandler)
  //       .then(response => {
  //           return response.json();
  //       })
  //       .then(data => {
  //         if (context.getters.getMode == "development") {
  //           resolve({ success: 26312908 });
  //         } else {
  //             resolve(data);
  //         }
  //       })
  //       .catch(error => {
  //         console.log("error", error);
  //         reject(error);
  //       });
  //   });
  // },
  sendfaqError: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/supporterror", {
        method: "POST",
        body: data
      })
      .then(errorServeiceHandler)
      .then(response => {
          return response.json();
      })
      .then(data => {
        if (context.getters.getMode == "development") {
          resolve({ success: 26467977 });
        } else {
            resolve(data);
        }
      })
      .catch(error => {
        if (context.getters.getMode == "development") {
          resolve({ success: 26467977 });
        } 
        console.log("error", error);
        reject(error);
      });
    })
  },
  retrackFaq: (context) => {
    return new Promise((resolve, reject) => {

      fetch(context.getters.baseUrl + "/subscriber/v1/retrack", {
        method: "POST",
      })
      .then(errorServeiceHandler)
      .then(response => {
          return response.json();
      })
      .then(data => {
        if (context.getters.getMode == "development") {
          resolve({ success: 26467977 });
        }
        else {
          resolve(data);
        }
      })
      .catch(error => {
        if (context.getters.getMode == "development") {
          resolve({ success: 26467977 });
        } 
        reject(error);
      });
    })
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/help/faq.js